import { motion } from "framer-motion";
import React, { useState } from "react";
import "./ContactScreen.css";
import Navbar from "./Navbar";
import { Button } from "@material-ui/core";
import emailjs from "emailjs-com";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const Result = () => {
	return (
		<p className="send">
			<CheckCircleIcon />
			Your response has been successfully sent. I will reach you soon.
		</p>
	);
};
function ContactScreen() {
	const pageVariants = {
		initial: {
			opacity: 0,
			x: "-100vw",
		},
		in: {
			opacity: 1,
			x: 0,
		},
		out: {
			opacity: 0,
			x: "100vw",
		},
	};
	const pageTransition = {
		type: "spring",
		stiffness: 45,
		duration: 0.2,
	};
	const [result, setResult] = useState(false);
	const sendEmail = (e) => {
		e.preventDefault();

		emailjs
			.sendForm(
				"service_aymisrt",
				"template_lf3h4qy",
				e.target,
				"user_BinIwCsO093qbBTxy4wBE"
			)
			.then(
				(result) => {
					console.log(result.text);
				},
				(error) => {
					console.log(error.text);
				}
			);
		e.target.reset();
		setResult(true);
	};
	setTimeout(() => {
		setResult(false);
	}, 3000);
	return (
		<div className="contactScreen">
			<Navbar />
			<motion.div
				className="section"
				initial="out"
				animate="in"
				exit="out"
				variants={pageVariants}
				transition={pageTransition}
			>
				<div className="container">
					<h2>Contact me</h2>
					<form onSubmit={sendEmail}>
						<div className="row100">
							<div className="col">
								<div className="inputBox">
									<input type="text" required="required" name="fullName" />
									<span className="inputBox__text">Name :</span>
									<span className="line"></span>
								</div>
							</div>
						</div>
						<div className="row100">
							<div className="col">
								<div className="inputBox">
									<input type="email" required="required" name="email" />
									<span className="inputBox__text">Email :</span>
									<span className="line"></span>
								</div>
							</div>
						</div>
						<div className="row100">
							<div className="col">
								<div className="inputBox textarea">
									<textarea required="required" name="message"></textarea>
									<span className="inputBox__text">Type your message here</span>
									<span className="line"></span>
								</div>
							</div>
						</div>
						<div className="row100">
							<div className="col">
								<Button type="submit" variant="contained" className="btn">
									Submit
								</Button>
							</div>
						</div>
					</form>
					<div className="submit">{result ? <Result /> : null}</div>
				</div>
			</motion.div>
		</div>
	);
}

export default ContactScreen;
